import React, { createContext, useState } from "react";
import { DecisionDialogBox } from "./decisionDialogBox";

interface DecisionDialogBoxContextProps {
  showDecisionDialogBox: (
    open: boolean,
    title: string,
    message: string,
    confirm: () => void,
    onContinue?: () => void
  ) => void;
}

const DecisionDialogBoxContext =
  createContext<DecisionDialogBoxContextProps | null>(null);

export const DecisionDialogBoxProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [onConfirmCallback, setOnConfirmCallback] = useState<() => void>(
    () => {}
  );
  const [onLeaveCallback, setOnLeaveCallback] = useState<() => void>(() => {});

  return (
    <DecisionDialogBoxContext.Provider
      value={{
        showDecisionDialogBox: (
          open: boolean,
          title: string,
          message: string,
          confirm: () => void,
          onContinue?: () => void
        ) => {
          setOpen(open);
          setTitle(title);
          setMessage(message);
          setOnConfirmCallback(() => confirm);
          setOnLeaveCallback(() => onContinue || (() => {}));
        },
      }}
    >
      {children}
      <DecisionDialogBox
        open={open}
        message={message}
        title={title}
        onClose={() => setOpen(false)}
        onConfirm={() => {
          onConfirmCallback();
          setOpen(false);
        }}
        onContinue={() => {
          onLeaveCallback();
          setOpen(false);
        }}
      />
    </DecisionDialogBoxContext.Provider>
  );
};

export const useDialogBoxContext = (): DecisionDialogBoxContextProps => {
  const context = React.useContext(DecisionDialogBoxContext);
  if (!context) {
    throw new Error("Dialog Box Error");
  }
  return context;
};

export const divSettingsState = {
  unsaved: false,
  save: () => {},
  cancel: () => {},
};